import React from 'react';
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, Cell, LabelList } from 'recharts';

interface SectorHeatmapProps {
    data: any[]; // { sector, avgYtd, count, ... }
    theme: any;
}

export const SectorHeatmap: React.FC<SectorHeatmapProps> = ({ data, theme }) => {
    // Sort by performance descending
    const sortedData = [...data]
        .filter(d => d.count > 0)
        .sort((a, b) => (b.avgYtd ?? 0) - (a.avgYtd ?? 0))
        .map(d => ({
            ...d,
            name: d.sector.length > 25 ? d.sector.substring(0, 22) + '...' : d.sector,
            fullName: d.sector,
            perf: d.avgYtd ?? 0
        }));

    const getColor = (perf: number) => {
        if (perf >= 10) return '#00796B';
        if (perf >= 5) return '#26A69A';
        if (perf >= 0) return '#4DB6AC';
        if (perf > -5) return '#E57373';
        return '#C62828';
    };

    return (
        <ResponsiveContainer width="100%" height="100%">
            <BarChart
                data={sortedData}
                layout="vertical"
                margin={{ top: 5, right: 60, left: 10, bottom: 5 }}
            >
                <XAxis type="number" hide />
                <YAxis
                    type="category"
                    dataKey="name"
                    tick={{ fontSize: 11, fill: theme.text }}
                    width={150}
                    tickLine={false}
                    axisLine={false}
                />
                <Tooltip
                    content={({ active, payload }) => {
                        if (active && payload && payload.length) {
                            const d = payload[0].payload;
                            return (
                                <div style={{
                                    background: theme.boxBg,
                                    padding: 12,
                                    border: theme.border,
                                    borderRadius: 8,
                                    boxShadow: '0 4px 12px rgba(0,0,0,0.15)'
                                }}>
                                    <div style={{ fontWeight: 'bold', marginBottom: 4 }}>{d.fullName}</div>
                                    <div>Perf Moy: <span style={{ fontWeight: 'bold', color: d.perf >= 0 ? '#00b638' : '#ef5350' }}>{d.perf.toFixed(2)}%</span></div>
                                    <div>Titres: {d.count}</div>
                                </div>
                            );
                        }
                        return null;
                    }}
                />
                <Bar dataKey="perf" radius={[0, 4, 4, 0]}>
                    {sortedData.map((entry, index) => (
                        <Cell key={`cell-${index}`} fill={getColor(entry.perf)} />
                    ))}
                    <LabelList
                        dataKey="perf"
                        position="right"
                        content={(props: any) => {
                            const { x, y, width, value } = props;
                            return (
                                <text
                                    x={x + width + 5}
                                    y={y}
                                    dy={12}
                                    fontSize={11}
                                    fontWeight="bold"
                                    fill={theme.text}
                                >
                                    {typeof value === 'number' ? `${value.toFixed(1)}%` : ''}
                                </text>
                            );
                        }}
                    />
                </Bar>
            </BarChart>
        </ResponsiveContainer>
    );
};
